import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0353 = React.lazy(() => import('./symbols/0353_wi-fi_wlan_connect_internet'));
const Symbol0354 = React.lazy(() => import('./symbols/0354_wi-fi_wlan_connect_internet'));
const Symbol0355 = React.lazy(() => import('./symbols/0355_wi-fi_wlan_router'));
const Symbol0356 = React.lazy(() => import('./symbols/0356_database'));
const Symbol0357 = React.lazy(() => import('./symbols/0357_database_remote'));
const Symbol0358 = React.lazy(() => import('./symbols/0358_database_raid'));
const Symbol0359 = React.lazy(() => import('./symbols/0359_server_hosting'));
const Symbol0360 = React.lazy(() => import('./symbols/0360_network_connection_lan_computers'));
const Symbol0361 = React.lazy(() => import('./symbols/0361_network_lan_drives_backup_remote'));
const Symbol0362 = React.lazy(() => import('./symbols/0362_network_remote_folder_drive'));
const Symbol0363 = React.lazy(() => import('./symbols/0363_network_connection_computer_folder'));
const Symbol0364 = React.lazy(() => import('./symbols/0364_network_connection_computers'));
const Symbol0365 = React.lazy(() => import('./symbols/0365_network_connection_computers'));
const Symbol0366 = React.lazy(() => import('./symbols/0366_satellite_connection'));
const Symbol0367 = React.lazy(() => import('./symbols/0367_satellite_connection'));
const Symbol0368 = React.lazy(() => import('./symbols/0368_home_wi_fi_wireless_network'));
const Symbol0369 = React.lazy(
  () => import('./symbols/0369_wi-fi_wlan_connect_internet_signal_antenna')
);
const Symbol0370 = React.lazy(
  () => import('./symbols/0370_wi-fi_wlan_connect_internet_signal_antenna')
);
const Symbol0371 = React.lazy(() => import('./symbols/0371_bluetooth'));
const Symbol0372 = React.lazy(() => import('./symbols/0372_connection_wireless'));
const Symbol0373 = React.lazy(() => import('./symbols/0373_connection_world_internet_worldwide'));
const Symbol0374 = React.lazy(() => import('./symbols/0374_connection_world_internet_worldwide'));

export interface IProps {}

const Networking: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0353_wi-fi_wlan_connect_internet" symbol={<Symbol0353 />} />
      <LazySymbol id="0354_wi-fi_wlan_connect_internet" symbol={<Symbol0354 />} />
      <LazySymbol id="0355_wi-fi_wlan_router" symbol={<Symbol0355 />} />
      <LazySymbol id="0356_database" symbol={<Symbol0356 />} />
      <LazySymbol id="0357_database_remote" symbol={<Symbol0357 />} />
      <LazySymbol id="0358_database_raid" symbol={<Symbol0358 />} />
      <LazySymbol id="0359_server_hosting" symbol={<Symbol0359 />} />
      <LazySymbol id="0360_network_connection_lan_computers" symbol={<Symbol0360 />} />
      <LazySymbol id="0361_network_lan_drives_backup_remote" symbol={<Symbol0361 />} />
      <LazySymbol id="0362_network_remote_folder_drive" symbol={<Symbol0362 />} />
      <LazySymbol id="0363_network_connection_computer_folder" symbol={<Symbol0363 />} />
      <LazySymbol id="0364_network_connection_computers" symbol={<Symbol0364 />} />
      <LazySymbol id="0365_network_connection_computers" symbol={<Symbol0365 />} />
      <LazySymbol id="0366_satellite_connection" symbol={<Symbol0366 />} />
      <LazySymbol id="0367_satellite_connection" symbol={<Symbol0367 />} />
      <LazySymbol id="0368_home_wi_fi_wireless_network" symbol={<Symbol0368 />} />
      <LazySymbol id="0369_wi-fi_wlan_connect_internet_signal_antenna" symbol={<Symbol0369 />} />
      <LazySymbol id="0370_wi-fi_wlan_connect_internet_signal_antenna" symbol={<Symbol0370 />} />
      <LazySymbol id="0371_bluetooth" symbol={<Symbol0371 />} />
      <LazySymbol id="0372_connection_wireless" symbol={<Symbol0372 />} />
      <LazySymbol id="0373_connection_world_internet_worldwide" symbol={<Symbol0373 />} />
      <LazySymbol id="0374_connection_world_internet_worldwide" symbol={<Symbol0374 />} />
    </>
  );
});

export default Networking;
